export enum DepositDepotExpressEnum {
  SPOOL = 'SPOOL',
  UNIT = 'UNIT',
  MAILING = 'MAILING',
  ERL = 'LRE'
}

export enum ErlTypeEnum {
  ERL_UNIT = 'ERL_UNIT',
  ERL_PUBLI = 'ERL_PUBLI'
}
